import { Box } from '@mui/material'
import TruncatedText from './TruncatedText'
import { memo, ReactElement } from 'react'
import { IMRTColumn } from '../Entity/interfaces'

interface IEntityFileTypeDataProps {
    dataValue: any
    item?: IMRTColumn
}

const EntityFileTypeData = ({
    dataValue,
}: IEntityFileTypeDataProps): ReactElement => {
    const value = dataValue

    let parsedValue: any = ''

    try {
        parsedValue = value ? JSON.parse(value) : ''
    } catch (e) {
        console.error('Error parsing file dataValue:', e)
    }

    const updatedFilePath = parsedValue?.path || ''

    const onClickFileInTable = (path: string) => {
        window.open(path, '_blank', 'noopener,noreferrer')
    }

    return (
        <Box
            onClick={
                updatedFilePath
                    ? () => onClickFileInTable(updatedFilePath)
                    : undefined
            }
            sx={{
                color: updatedFilePath ? '#6d6dff' : '',
                cursor: updatedFilePath ? 'pointer' : '',
                width: '100%',
            }}
        >
            <TruncatedText text={parsedValue?.name || ''} />
        </Box>
    )
}

const MemoizedEntityFileTypeData = memo(EntityFileTypeData)
MemoizedEntityFileTypeData.displayName = 'EntityFileTypeData'
export default MemoizedEntityFileTypeData
